// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAGQvQG_4fFk0o3YVWYLLACrOPDW6vntFQ",
  authDomain: "collegeproj-d1cd4.firebaseapp.com",
  databaseURL: "https://collegeproj-d1cd4-default-rtdb.firebaseio.com",
  projectId: "collegeproj-d1cd4",
  storageBucket: "collegeproj-d1cd4.firebasestorage.app",
  messagingSenderId: "375003611534",
  appId: "1:375003611534:web:02161cb6cd652c7b0624df",
  measurementId: "G-1ZRY1NV269"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// Export Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

// You can also export the app instance if needed for other Firebase services
export default app;